import styled from 'styled-components';
export const StyledTableBody = styled.tbody `
  opacity: 1;
  transition: opacity var(--table-loading-transition);

  ${({ $subsequentLoading }) => $subsequentLoading && `opacity: 0.2;`}

  &:before {
    content: '';
    background: transparent;
    display: var(--table-display-head-body-gap);
    height: var(--table-display-head-body-gap-spacing);
  }
`;
